import { oktaAuth } from './okta-config'

export const performOktaLogout = async (mode = 'remote') => {
  if (mode === 'local') {
    await oktaAuth.tokenManager.clear()
    return
  }

  const idToken = await oktaAuth.tokenManager.get('idToken')

  if (!idToken) {
    await oktaAuth.tokenManager.clear()
    return
  }

  try {
    await oktaAuth.signOut({
      idToken,
      postLogoutRedirectUri: window.location.origin,
      clearTokensBeforeRedirect: true
    })
  } catch (error) {
    console.warn('Okta signOut failed. Falling back to local token clear.', error)
    await oktaAuth.tokenManager.clear()
  }
}
